import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=36f266f0&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f266f0')) {
      api.createRecord('36f266f0', component.options)
    } else {
      api.reload('36f266f0', component.options)
    }
    module.hot.accept("./accordion.vue?vue&type=template&id=36f266f0&", function () {
      api.rerender('36f266f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/info-menu/accordion.vue"
export default component.exports